import useAppDispatch from '@/hooks/useAppDispatch'
import useAppSelector from '@/hooks/useAppSelector'
import {
  selectIsShowing,
  selectSearchTerm,
  setIsShowing,
  setSearchTerm,
} from '@/redux/slices/globalSearch'

export function useGlobalSearch() {
  const isShowing = useAppSelector(selectIsShowing)
  const searchTerm = useAppSelector(selectSearchTerm)
  const dispatch = useAppDispatch()

  return {
    searchTerm,
    isShowing,
    show: () => dispatch(setIsShowing(true)),
    // Closing always resets the term, so the palette opens empty next time —
    // regardless of how it was closed (Esc, overlay, close button, result
    // click, etc.).
    hide: () => {
      dispatch(setIsShowing(false))
      dispatch(setSearchTerm(''))
    },
    clear: () => dispatch(setSearchTerm('')),
    setSearchTerm: (searchTerm: string) => dispatch(setSearchTerm(searchTerm)),
  }
}
